import { QueryCache } from 'react-query';

// FIXME: do not expose react-query cache publicly
// Instead of exposing the full object, we should only expose the functions we
// want to use
export const createQueryCache = (): QueryCache => new QueryCache();

export { QueryCache } from 'react-query';
